import { createFileRoute } from "@tanstack/react-router"
import { useQuery } from "convex/react"
import { useState } from "react"
import { api } from "../../../../convex/_generated/api"

export const Route = createFileRoute("/_authed/admin/audit")({
  component: AdminAudit,
})

function AdminAudit() {
  const [prefix, setPrefix] = useState("")
  const rows = useQuery(api.audit.list, {
    limit: 200,
    actionTypePrefix: prefix || undefined,
  })

  return (
    <div className="space-y-4">
      <header className="flex items-center justify-between gap-2">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">Audit log</h1>
          <p className="mt-1 text-sm text-[color:var(--muted-foreground)]">
            Every admin state change. Read-only.
          </p>
        </div>
        <input
          type="text"
          value={prefix}
          onChange={(e) => setPrefix(e.target.value)}
          aria-label="Filter audit log by action prefix"
          placeholder="Filter by action prefix (e.g. economy.)"
          className="w-72 rounded-md border border-[color:var(--border)] bg-[color:var(--muted)] px-2 py-1 text-xs"
        />
      </header>

      {!rows ? (
        <p className="text-sm text-[color:var(--muted-foreground)]">Loading…</p>
      ) : rows.length === 0 ? (
        <p className="text-sm text-[color:var(--muted-foreground)]">
          No audit rows match.
        </p>
      ) : (
        <div className="rounded-md border border-[color:var(--border)]">
          <table className="w-full text-xs">
            <thead className="bg-[color:var(--muted)] uppercase tracking-wide text-[color:var(--muted-foreground)]">
              <tr>
                <th className="px-3 py-2 text-left">Time</th>
                <th className="px-3 py-2 text-left">Action</th>
                <th className="px-3 py-2 text-left">Actor</th>
                <th className="px-3 py-2 text-left">Target</th>
                <th className="px-3 py-2 text-left">Detail</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[color:var(--border)]">
              {rows.map((row) => (
                <tr key={row._id}>
                  <td className="px-3 py-2 font-mono whitespace-nowrap">
                    {new Date(row.createdAt).toLocaleString()}
                  </td>
                  <td className="px-3 py-2 font-mono">{row.actionType}</td>
                  <td className="px-3 py-2">
                    {row.actor?.displayName ?? row.actor?.email ?? "—"}
                  </td>
                  <td className="px-3 py-2 font-mono">
                    {row.targetEntity ?? "—"}
                  </td>
                  <td className="px-3 py-2">
                    {row.after ? (
                      <code className="font-mono text-[10px]">
                        {JSON.stringify(row.after).slice(0, 120)}
                      </code>
                    ) : (
                      "—"
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
